import React from 'react';
import ColorPicker from 'src/components/ColorPicker/ColorPicker';
import { Item as ItemWrapper } from 'src/components/Layouts';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const ResponsiveText = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data, onChange, hideBkgColor } = props;
  const {
    backgroundColor,
    productNameColor,
    bodyTextColor,
    listPriceColor,
    otherPriceColor,
  } = data || {};

  return (
    <React.Fragment>
      {!hideBkgColor && (
        <ItemWrapper size='small' title={getI18n('general.backgroundColour')}>
          <ColorPicker
            color={backgroundColor}
            multi
            onChange={(backgroundColor) => {
              onChange({ backgroundColor });
            }}
          />
        </ItemWrapper>
      )}{' '}
      <ItemWrapper size='small' title={getI18n('general.productNameColour')}>
        <ColorPicker
          color={productNameColor}
          multi
          onChange={(productNameColor) => {
            onChange({ productNameColor });
          }}
        />
      </ItemWrapper>{' '}
      <ItemWrapper size='small' title={getI18n('general.bodyTextColour')}>
        <ColorPicker
          color={bodyTextColor}
          multi
          onChange={(bodyTextColor) => {
            onChange({ bodyTextColor });
          }}
        />
      </ItemWrapper>{' '}
      <ItemWrapper size='small' title={getI18n('general.listPriceColour')}>
        <ColorPicker
          color={listPriceColor}
          multi
          onChange={(listPriceColor) => {
            onChange({ listPriceColor });
          }}
        />
      </ItemWrapper>{' '}
      <ItemWrapper size='small' title={getI18n('general.otherPriceColour')}>
        <ColorPicker
          color={otherPriceColor}
          multi
          onChange={(otherPriceColor) => {
            onChange({ otherPriceColor });
          }}
        />
      </ItemWrapper>
    </React.Fragment>
  );
};
export default ResponsiveText;
